import { render, staticRenderFns } from "./bussinessType.vue?vue&type=template&id=1a299694&scoped=true"
import script from "./bussinessType.vue?vue&type=script&lang=js"
export * from "./bussinessType.vue?vue&type=script&lang=js"
import style0 from "./bussinessType.vue?vue&type=style&index=0&id=1a299694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a299694",
  null
  
)

export default component.exports